import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[pageHeaderMeganavContentArea]'
})
export class PageHeaderMaganavContentAreaDirective implements OnInit, OnDestroy {
    /**
     * Toggle id entry to catch events
     */
    @Input()
    toggleClassBy?: NToggle.TId;

    /**
     * Subscription
     */
    private subscription!: Subscription;

    /**
     * Dependencies
     */
    constructor(private elementRef: ElementRef, private toggleService: ToggleService) {}

    /**
     * Initialise
     */
    ngOnInit(): void {
        // scroll wrapper back to top when we openinig
        if (this.toggleClassBy) {
            this.subscription = this.toggleService.getItem(this.toggleClassBy).state.subscribe(visible => {
                if (visible) {
                    this.elementRef.nativeElement.scrollTop = 0;
                }
            });
        }
    }

    /**
     * Cleanup
     */
    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
}
